<template>
    <section>
      <div>
        <b-row>
            <b-modal id="modal-1" title="Formulario de tickets"  size="lg" @hide="limpiarFormulario" hide-footer>
              <Tickets :admin="true" :hideModal="limpiarFormulario"></Tickets>
            </b-modal>
            <b-col :sm="cols">
              <ListTickets></ListTickets>
            </b-col>
        </b-row>
      </div>
    </section>
</template>

<script>
import {mapState, mapMutations, mapActions} from 'vuex'

import Tickets from './Tickets'
import ListTickets from './ListTickets'
import Table from './Table'
import Detalle from './Detalle'

import loader from "../../containers/loader";
import { getAcls } from '../../plugins/acl';


export default {
  name: 'ticket-main',
  components:{
    Tickets,
    ListTickets,
    Table,
    Detalle,
    loader
  },
  data() {
    return {
      cols: 12,
      reset: false
    }
  },
  async mounted() {
    var acls = getAcls();
    this.rol = acls.roles.toString();

    if(this.rol == "superadmin"){
        this.setRol('esSuperAdmin');
        this.cols = 12;
    }

    if(this.rol == "admin" || this.rol == "superadmin" || this.rol == "admin-tecnico" ){
        this.setRol('esAdmin');
        this.cols = 12;
    }else{
        this.setRol('esEmpresa');
    }
    this.createUsabilityEvents('ingreso_modulo_tickets');
  },
   computed: {
    ...mapState("tickets", [
        "pantalla",
        "loading",
        "esAdmin",
        "esEmpresa"
      ]),
  },
  methods: {
    limpiarFormulario() {
      this.resetSelectedTicket();
      this.$bvModal.hide('modal-1')
    },
    ...mapMutations('tickets',[
      'setRol',
      'resetSelectedTicket',
      'resetFiltro'
    ]),
    ...mapActions('tickets',[
      'getEstados'
    ]),
    ...mapActions("usabilityEvents", ["createUsabilityEvents"]),
  },
  beforeRouteLeave: function(to, from, next) {
    if (!to.path.includes('tickets')) {
      this.reset = true;
    } else {
      this.reset = false;
    }
    next();
  },
  beforeDestroy() {
    if (this.reset) {
      this.resetFiltro();
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
